import { useCallback, useState } from 'react';
import { MINIMAL_MOVING_STEP } from './constants';
export function useTouchBehaviors({ onClickPrevItem, onClickNextItem, isRightToLeft, }) {
    const [isDraggable, setIsDraggable] = useState(false);
    const [touchPosition, setTouchPosition] = useState(null);
    const touchStartHandler = useCallback((event) => {
        const touchDown = 'touches' in event ? event.touches[0].clientX : event.clientX;
        setTouchPosition(touchDown);
    }, []);
    const touchMoveHandler = useCallback((event) => {
        if (touchPosition === null) {
            return;
        }
        const currentTouch = 'touches' in event ? event.touches[0].clientX : event.clientX;
        const diff = touchPosition - currentTouch;
        // for case with direction -> ltr
        const isLtrDirectionNextItemExist = !isRightToLeft && diff > MINIMAL_MOVING_STEP;
        const isLtrDirectionPrevItemExist = !isRightToLeft && diff < -MINIMAL_MOVING_STEP;
        // for case with direction -> rtl
        const isRtlDirectionNextItemExist = isRightToLeft && diff > MINIMAL_MOVING_STEP;
        const isRtlDirectionPrevNextItemExist = isRightToLeft && diff < -MINIMAL_MOVING_STEP;
        if (isLtrDirectionNextItemExist || isRtlDirectionPrevNextItemExist) {
            onClickNextItem();
        }
        if (isLtrDirectionPrevItemExist || isRtlDirectionNextItemExist) {
            onClickPrevItem();
        }
        setTouchPosition(null);
    }, [isRightToLeft, onClickNextItem, onClickPrevItem, touchPosition]);
    const pointerDownHandler = useCallback((event) => {
        event.preventDefault();
        setIsDraggable(true);
        touchStartHandler(event);
    }, [touchStartHandler]);
    const pointerUpHandler = useCallback((event) => {
        setIsDraggable(false);
        touchMoveHandler(event);
    }, [touchMoveHandler]);
    return {
        touchStartHandler,
        touchMoveHandler,
        pointerDownHandler,
        pointerUpHandler,
        isDraggable,
    };
}
